import React from 'react';
import { PriceBoxStyle } from './styled';

function InnerHtml(props) {
  const { data, heading, updatedOn } = props;
  const date = new Date(updatedOn).toLocaleDateString('en-US');
  return (
    <PriceBoxStyle>
      {heading ? <div className="headingSection">{heading}</div> : null}
      <div
        dangerouslySetInnerHTML={{
          __html: data,
        }}
      ></div>
      {updatedOn ? <p> This data was last updated on {date}</p> : null}
    </PriceBoxStyle>
  );
}

export default InnerHtml;
